import type { DownloaderFontSchemaType, DownloaderSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import { ClearButton } from 'components/Editor/styled/Button'
import { border, font, hover } from 'services/Branding/common.styled'
import type { ElementFontCss, ElementStyleCss } from 'services/Branding/types'

const DownloaderStyled = styled(ClearButton)<{
  $styles: ElementStyleCss<DownloaderSchemaType>
  $fonts: ElementFontCss<DownloaderFontSchemaType>
}>`
  display: flex;
  height: 100%;
  align-items: center;
  text-decoration: none;
  cursor: pointer;

  background-color: ${({ $styles }) => $styles.downloader.backgroundColor};
  box-shadow: ${({ $styles }) => $styles.effects.boxShadow};

  ${({ $fonts }) => font($fonts.base)}
  ${({ $styles }) => border($styles.border)}
  ${hover}
  &:hover {
    color: ${({ $fonts }) => $fonts.base.color};
  }
`

export default DownloaderStyled
